var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_9393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.272767 8.16235C-0.0899568 7.79614 -0.0899567 7.20141 0.272767 6.8352L4.91562 2.1477C5.27835 1.78149 5.86741 1.78149 6.23013 2.1477C6.59286 2.51392 6.59286 3.10864 6.23013 3.47485L3.16875 6.56274L12.0714 6.56274C12.585 6.56274 13 6.98169 13 7.50024C13 8.0188 12.585 8.43774 12.0714 8.43774L3.17165 8.43774L6.22723 11.5256C6.58995 11.8918 6.58995 12.4866 6.22723 12.8528C5.86451 13.219 5.27544 13.219 4.91272 12.8528L0.269864 8.16528L0.272767 8.16235Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_9393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 15,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 13 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.01164f1f037cec57484667e93864c05f.svg";
export { ForwardRef as ReactComponent };